import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgxFileDropEntry } from "ngx-file-drop";
import { Subject } from "rxjs";
import { BaseComponent } from "src/app/@base/base.component";

export declare type DisplayOptions = 'area' | 'button';

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
})
export class FileUploadComponent extends BaseComponent implements OnInit {

  @ViewChild("openFileSelectorElement") openFileSelectorElement: ElementRef

  @Input() clearFiles: Subject<void> = new Subject<void>;
  @Output() emitFileUploaded: EventEmitter<any> = new EventEmitter<any>();

  @Input() display: DisplayOptions = "area";
  @Input() uploadDescription: string = "Arraste e solte aqui um arquivo";
  @Input() customDataCy: string = "file-drop";
  @Input() loading: boolean = false;
  @Input() fileTypes: string[] = [];
  @Input() useBase64EncodedFiles: boolean = true;
  @Input() sizeLimit: number = null; //In MB
  @Input() disabled: boolean;
  @Input() hasMaxWidthSupportOf?: number = null;
  @Input() hasMaxHeightSupportOf?: number = null;

  public files: NgxFileDropEntry[] = [];
  public showButtonUpload: boolean = true;
  public nameDocumentSelected: string;
  public isMobile: boolean = false;

  @HostListener('window:resize', [])
  onResize(): void {
    this.checkDevice();
  }
  
  public ngOnInit(): void {
    this.checkDevice();
    
    this.clearFiles.subscribe(() => {
      this.onClickRemoveFileSelected();
      this.files = [];
    });
  }

  public async dropped(files: NgxFileDropEntry[]): Promise<void> {
    let validFiles = files.filter((file) => file.fileEntry.isFile)
    let fileResponses = []


    for (let i = 0; i < validFiles.length; i++) {
      const fileEntry = validFiles[i].fileEntry as FileSystemFileEntry;

      // Force Event loop to wait for promise resolution to continue executing
      fileResponses.push(await new Promise((resolve, reject) => {
        fileEntry.file(f => {
          if (this.sizeLimit !== null) {
            if (this.ToMegabyte(f.size) > this.sizeLimit) {
              this.openDialogMessage("Não é possível fazer o upload deste arquivo. Arquivo com tamanho superior à " + this.sizeLimit + "MB.")
              return;
            }
          }


          this.nameDocumentSelected = f.name
          this.showButtonUpload = false;

          if (["image/png", "image/jpeg", "image/jpeg"].includes(f.type)) {
            this.invalidVerifyImageFileSize(f).then(invalid => {
              if (invalid) {
                this.openErrorDialog("Tamanho Inválido", `Imagem tem o tamanho inválido, imagens devem ter o tamanho máximo de ${this.hasMaxWidthSupportOf}x${this.hasMaxHeightSupportOf}`)
                resolve(null)
                return;
              }

              resolve(f);
            })

          } else {
            resolve(f);
          }

        })
      }))
    }

    if (fileResponses.some(f => f == null)) {
      this.clearFiles.next();
      return;
    }

    if (this.useBase64EncodedFiles) {
      return this.returnFileRequestList(fileResponses).then((files) => this.emitFileUploaded.emit(files));
    }

    this.emitFileUploaded.emit(fileResponses);
  }

  private invalidVerifyImageFileSize(file: File): Promise<boolean> {
    const image = new Image();
    return new Promise((resolve, reject) => {
      image.onload = () => {
        if (this.hasMaxWidthSupportOf && image.width > this.hasMaxWidthSupportOf) {
          resolve(true);
          return
        }

        if (this.hasMaxHeightSupportOf && image.height > this.hasMaxHeightSupportOf) {
          resolve(true);
          return
        }

        resolve(false);
        return
      }

      image.onerror = () => resolve(true);

      image.src = URL.createObjectURL(file);
    })

  }

  public onClickOpenFileSelector(): void {
    if (!this.disabled) {
      this.openFileSelectorElement.nativeElement.click()
    }
  }

  public onClickRemoveFileSelected(): void {
    this.nameDocumentSelected = null;
    this.showButtonUpload = true;
    this.emitFileUploaded.emit(null);
  }

  private ToMegabyte(mega: number) {
    return mega / 1024 / 1024;
  }

  private checkDevice(): void {
    this.isMobile = window.innerWidth <= 768;
  }
}
